import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
         Welcome the the Billowing Flower 86da React App!  This is a test of the React App.
        </p>
      </header>
    </div>
  );
}

export default App;
